<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      v-if="!create"
      :schema="schema"
      name="code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.code"
        :form-state="formState"
        name="code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.code"
        readonly
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="date_quoted"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_quoted"
        name="date_quoted"
        v-bind="schema.fields.date_quoted"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="supervisor"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.supervisor_name"
        :form-state="formState"
        name="supervisor"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.supervisor"
      >
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="purchase_order_number"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.purchase_order_number"
        :form-state="formState"
        name="purchase_order_number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.purchase_order_number"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="job"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <job-search
        v-model="item.job"
        :form-state="formState"
        name="job"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.job"
        @update-job="updateJob"
        :create="create"
        :address="item.site_address"
        :suburb="item.suburb"
        :job_number="item.job_number"
      >
      </job-search>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="builder"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        :value="item.builder__name || item.job__customer__name"
        :items="optionCustomerItems"
        text-field="name"
        value-field="id"
        sort-field="name"
        :form-state="formState"
        :loading="optionCustomerWorking"
        name="builder"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.builder"
        readonly
      >
      </o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="site_address"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.site_address"
        :form-state="formState"
        name="site_address"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.site_address"
        readonly
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="suburb"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.suburb"
        :form-state="formState"
        name="suburb"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.suburb"
        readonly
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="description"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.description"
        :form-state="formState"
        name="description"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.description"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="amount"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-money-field
        prepend="$"
        v-model="item.amount"
        :form-state="formState"
        name="amount"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.amount"
      ></o-money-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="quoted_by"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.quoted_by"
        :form-state="formState"
        name="quoted_by"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.quoted_by"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="po_no_supplied"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.po_no_supplied"
        :form-state="formState"
        name="po_no_supplied"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.po_no_supplied"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="date_po_supplied"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.date_po_supplied"
        name="date_po_supplied"
        v-bind="schema.fields.date_po_supplied"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="comments"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-area
        v-model="item.comments"
        :form-state="formState"
        name="comments"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.comments"
      ></o-text-area>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="completed_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.completed_date"
        name="completed_date"
        v-bind="schema.fields.completed_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="cancelled_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.cancelled_date"
        name="cancelled_date"
        v-bind="schema.fields.cancelled_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
        hide-time
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="!create"
      :schema="schema"
      name="extra"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <extra-search
        v-model="item.extra"
        :form-state="formState"
        name="extra"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.extra"
        @update-extra="updateExtra"
        :create="create"
        :extra_number="item.extra_number"
      >
      </extra-search>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="repair_files"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-files-table
        v-model="item.repair_files"
        model-name="FileUpload"
        :users="optionUserItemsById"
        :users-working="optionUserWorking"
        :file-types="optionCodeFileTypeItems"
        :file-types-working="optionCodeFileTypeWorking"
        other-name="service_maintenance"
        :parent-id="item.id || 0"
        who-field="who_uploaded"
        when-field="when_uploaded"
        :validators="$v.item.repair_files"
        :form-state="formState"
        :label="schema.fields.repair_files.label"
        :level="level + 1"
        :server-errors="_se.repair_files"
      >
      </o-files-table>
      <!-- UNCOMMENT TO USE Cards
<file-upload-form-cards v-model="item.repair_files"
    :validators="$v.item.repair_files"
    :form-state="formState"
    :label="schema.fields.repair_files.label"
    :level="level+1"
    :server-errors="_se.repair_files">
</file-upload-form-cards>
--> </o-widget-wrapper
    ><br />

    <o-widget-wrapper
      :schema="schema"
      name="repair_notes"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-notes-table
        v-model="item.repair_notes"
        :validators="$v.item.repair_notes"
        :form-state="formState"
        :label="schema.fields.repair_notes.label"
        :level="level + 1"
        :server-errors="_se.repair_notes"
      >
      </o-notes-table>
      <!-- UNCOMMENT TO USE Cards
<note-form-cards v-model="item.repair_notes"
    :validators="$v.item.repair_notes"
    :form-state="formState"
    :label="schema.fields.repair_notes.label"
    :level="level+1"
    :server-errors="_se.repair_notes">
</note-form-cards>
--> </o-widget-wrapper
    ><br />

    <o-widget-wrapper
      :schema="schema"
      name="used_materials"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <repair-materials-used-form-table
        v-model="item.used_materials"
        :validators="$v.item.used_materials"
        :form-state="formState"
        :label="schema.fields.used_materials.label"
        :level="level + 1"
        :server-errors="_se.used_materials"
        :create="create"
      >
      </repair-materials-used-form-table>
      <!-- UNCOMMENT TO USE Cards
<repair-materials-used-form-cards v-model="item.used_materials"
    :validators="$v.item.used_materials"
    :form-state="formState"
    :label="schema.fields.used_materials.label"
    :level="level+1"
    :server-errors="_se.used_materials">
</repair-materials-used-form-cards>
-->
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OTextArea from "../../../vue-ocom/components/forms/fields/OTextarea";
import ONotesTable from "../../../vue-ocom/components/table/common/ONotesTable";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";
import OFilesTable from "../../../vue-ocom/components/table/common/OFilesTable";

import { default as CustomerForm } from "../../customer/components/ItemForm";
import { default as ServiceExtraForm } from "../../service_extra/components/ItemForm";
import { default as JobForm } from "../../job/components/ItemForm";
import { default as SupervisorForm } from "../../supervisor/components/ItemForm";
// import { default as FileUploadFormTable } from '../../file_upload/components/ItemFormTable';
// import { default as FileUploadFormCards } from '../../file_upload/components/ItemFormCards';
import { default as RepairMaterialsUsedFormTable } from "../../repair_materials_used/components/ItemFormTable";
// import { default as RepairMaterialsUsedFormCards } from '../../repair_materials_used/components/ItemFormCards';
// import { default as NoteFormTable } from '../../note/components/ItemFormTable';
// import { default as NoteFormCards } from '../../note/components/ItemFormCards';
import { default as InvoiceFormTable } from "../../invoice/components/ItemFormTable";
// import { default as InvoiceFormCards } from '../../invoice/components/ItemFormCards';
import { default as JobSearch } from "../../components/job_search/JobSearch";
import { default as ExtraSearch } from "../../components/extra_search/ExtraSearch";
import OMoneyField from "@/app/components/money_field/OMoneyField.vue";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ServiceMaintenance"),
    CreateCodeTableFetchMixin([
      "Customer",
      "ServiceExtra",
      "Supervisor",
      "User",
      "CodeFileType",
    ]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextArea,
    ONotesTable,

    CustomerForm,
    ServiceExtraForm,
    JobForm,
    SupervisorForm,
    //FileUploadFormTable,
    //FileUploadFormCards,
    RepairMaterialsUsedFormTable,
    //RepairMaterialsUsedFormCards,
    //NoteFormTable,
    //NoteFormCards,
    InvoiceFormTable,
    //InvoiceFormCards,
    OFilesTable,
    JobSearch,
    ExtraSearch,
    OMoneyField,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
    create: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.ServiceMaintenance, {}),
  }),
  methods: {
    updateJob(e) {
      this.item.job = e.id;
      this.item.site_address = e.site_address;
      this.item.suburb = e.suburb;

      if (e.customer) {
        this.item.builder = e.customer;
        this.item.builder__name = e.customer__name;
      }
    },
    updateExtra(e) {
      this.item.extra = e.id;
      this.item.extra_number = e.code;
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
